<template>
    <div v-if="activity">
        <template v-for="(u, index) in activity">
            <v-list-item three-line :key="'academy_update' + index" class="text-left" @click="viewUpdate(u.value, u)">
                <v-list-item-avatar>
                    <ImageDisplay v-if="u.user && u.user.userImageSmall" :src="u.user.userImageSmall" />
                    <img v-else-if="u.user" :src="assets('default-profile-avatar.png')" />
                    <v-icon v-else size="35">mdi-cog-sync-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="plusGreyDarken4--text" v-if="u.user">
                        {{ u.user && u.user.displayName ? u.user.displayName : $t("message.unknown") }}
                    </v-list-item-title>
                    <v-list-item-title v-else>
                        {{ $t("message.system") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="plusGreyDarken2--text">
                        {{ $d(new Date(u.time), "short", $i18n.locale) }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="plusGreyDarken1--text">
                        {{ $t("message.admin_action_" + u.action) }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index + 1 < activity.length" :key="index"></v-divider>
        </template>
        <v-dialog v-model="academyUpdateDialog" max-width="90%">
            <v-card class="pa-2">
                <v-card-text>
                    <div class="mb-1">
                        <v-chip small>val</v-chip> :
                        <v-chip small>{{ academyUpdateDialogValue }}</v-chip>
                    </div>
                    <div v-if="selectedActivity && selectedActivity.raw">
                        <div class="mb-1" v-for="(value, key) in selectedActivity.raw" :key="key">
                            <v-chip small>{{ key }}</v-chip> :
                            <v-chip small>{{ value }}</v-chip>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="" 0 @click="closeAcademyUpdateDialog()">
                        {{ $t("message.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ImageDisplay from "@/components/displays/ImageDisplay.vue";
export default {
    components: { ImageDisplay },
    props: [
        'activity',
    ],
    data() {
        return {
            selectedActivity: null,
            academyUpdateDialog: null,
            academyUpdateDialogValue: null
        }
    },
    methods: {
        viewUpdate(val, el) {
            this.academyUpdateDialogValue = val;
            this.academyUpdateDialog = true;
            if (el) {
                this.selectedActivity = el;
            }
        },
        closeAcademyUpdateDialog() {
            this.academyUpdateDialogValue = null;
            this.academyUpdateDialog = false;
        },
        parseJsonSafe(jsonString) {
            try {
                return JSON.parse(jsonString);
            } catch (error) {
                console.error("Invalid JSON string provided:", error);
                return null; // Return empty object as fallback
            }
        }
    },
}
</script>

<style scoped></style>
